import { AUTH_TOKEN, USER_AUTHENTICATED } from '@/helpers'

export default {
   user: {
      data: JSON.parse(localStorage.getItem(USER_AUTHENTICATED)) || { userId: '', name: '', email: '', profile: '' },
      token: localStorage.getItem(AUTH_TOKEN) || null
   }
}
